import { gql } from '@apollo/client'

export const DELETE_BLOG_POST_MUTATION = gql`
  mutation deleteBlogPost($id: ID!) {
    deleteBlogPost(id: $id)
  }
`
